import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const EkgIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.7 15.662",
    height: getDefaultHeight(svgProps, 15.662),
    ...svgProps,
    children: /*#__PURE__*/jsx("path", {
      d: "M21.7 7.83h-3.114a.453.453 0 01-.391-.276L15.019 1.28a.445.445 0 00-.42-.275.486.486 0 00-.391.341L9.287 14.318a.486.486 0 01-.391.341.445.445 0 01-.42-.275L5.301 8.107a.453.453 0 00-.391-.276H1",
      fill: "none",
      stroke: color ?? "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    })
  });
};

export { EkgIcon };
//# sourceMappingURL=ekg.js.map
